export function hasHydratableTemplateContent(templateData: unknown): boolean {
  if (!templateData || typeof templateData !== 'object') {
    return false;
  }

  const record = templateData as Record<string, unknown>;
  return Array.isArray(record.layers) ||
    Array.isArray(record.document_pages) ||
    Array.isArray(record.documentPages) ||
    Array.isArray(record.document_layers) ||
    Array.isArray(record.documentLayers);
}

export function resolveImportedTemplatePayload(input: unknown): Record<string, unknown> | null {
  if (!input || typeof input !== 'object') {
    return null;
  }

  const candidate = input as Record<string, unknown>;
  if (hasHydratableTemplateContent(candidate)) {
    return candidate;
  }

  const nested = candidate.data;
  if (nested && typeof nested === 'object' && hasHydratableTemplateContent(nested)) {
    return nested as Record<string, unknown>;
  }

  return null;
}
